module.exports = __webpack_public_path__ + "img/concrete_white_grey_ba_list.a2a49065.jpg";